<template>
  <section class="face-current-time-and-expanded-centered-qr">
    <div>
      <div v-if="showQRDisplaySection" class="current-time-and-qr-section">
        <div class="current-datetime">
          <div class="current-time-label">現在時刻</div>
          <div class="current-time-value">{{ currentTime }}</div>
        </div>
        <div class="qr-or-reload-section">
          <!-- QRコード(GIFアニメーション版) -->
          <img
            v-if="showQRByAnimationUrl"
            class="animation qr"
            :src="animationUrl"
          />

          <!-- リロードボタン(有効期間外)+QRコード(ネットワークエラー時) -->
          <FaceQRReloadSectionCenteredQR
            v-else-if="isCenteredQrReloadSection"
            :on-tap-reload="onTapReload"
            :has-network-speed-issue="hasNetworkSpeedIssue"
            :qr-string="qrString"
          />

          <!-- QRコード(有効期間内) かつ ネットワーク正常 -->
          <vue-qrcode
            v-else-if="isValidQrString && !hasNetworkSpeedIssue"
            class="qr"
            :value="qrString"
            tag="img"
          ></vue-qrcode>
        </div>
      </div>
    </div>
    <div class="spacer"></div>
    <Copyright class="copyright" />
  </section>
</template>

<script>
import FaceQRReloadSectionCenteredQR from "./FaceQRReloadSectionCenteredQR.vue";
import passService from "@/services/pass";

export default {
  name: "FaceCurrentTimeAndExpandedCenteredQR",
  components: { FaceQRReloadSectionCenteredQR },
  props: {
    animationUrl: {
      type: String,
      required: true,
    },
    isValidQrString: {
      type: Boolean,
      required: false,
      default: null,
    },
    qrString: {
      type: String,
      required: true,
    },
    onTapReload: {
      type: Function,
      required: true,
    },
    hasNetworkSpeedIssue: {
      type: Boolean,
      required: true,
    },
    isLoadingQRInfo: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      currentTime: this.formatCurrentTime(),
    };
  },
  computed: {
    showQRDisplaySection() {
      return this.isValidQrString !== null || this.animationUrl !== "";
    },
    showQRByAnimationUrl() {
      const animationQrUrl =
        "https://contents-staging.maasjapan.net/master_pass/1583/images/ja-animation.gif";
      return this.animationUrl === animationQrUrl;
    },
    isCenteredQrReloadSection() {
      return passService.checkIsCenteredQrReloadSection({
        isCenteredQR: true, // CenteredQR専用コンポーネントのためtrueで固定
        isLoadingQRInfo: this.isLoadingQRInfo,
        isValidQrString: this.isValidQrString,
        hasNetworkSpeedIssue: this.hasNetworkSpeedIssue,
      });
    },
  },
  mounted() {
    setInterval(() => this.updateCurrentTime(), 1 * 1000);
  },
  methods: {
    formatCurrentTime() {
      return this.$moment().format("YYYY.MM.DD HH:mm:ss");
    },
    updateCurrentTime() {
      this.currentTime = this.formatCurrentTime();
    },
  },
};
</script>

<style lang="scss">
.face-current-time-and-expanded-centered-qr {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 24px;
}

.current-datetime {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1.33vw;
}

.current-time-label {
  font-weight: 500;
  font-size: 3.73vw;
  line-height: 5.33vw;
  color: #000000;
}

.current-time-value {
  font-weight: 700;
  font-size: 6.4vw;
  line-height: 7.73vw;
  color: #eb5757;
}

.current-time-and-qr-section {
  width: 100vw;
  margin-bottom: calc(31 / 812 * 100vh);
}

.qr {
  width: 150px;
  height: 150px;
  display: block;
  margin-inline: auto;
}

.spacer {
  height: 3.82vh;
}
</style>
